// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { EU, EUG, currency, generateId, isMobile } from '../_common/api/utility';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import Card from '../_pwa/Card';
import Loading from '../_common/Loading';
import Icon from '../_common/form/Icon';
import LocationList from '../_common/LocationList';
import Button from '../_common/form/Button';
import { generateQR } from '../_pwa/WashClub';
import { QuestRoute } from '../_common/api/QuestRoutes';
import Modal from '../_common/Modal';
import Title from '../_common/form/Title';
import { Routes } from 'react-router-dom';
import { HamQuest } from '../../App';

const Wrapper = styled.div`
    padding: 1em 0;
`
const Item = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    
    padding: 0.5em 0.5em;

    border-top: 1px solid ${({ theme }) => theme.secondary};
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`
const Row = styled.div`
    display: flex;
    justify-content: space-between;
`
const Indent = styled.div`
    padding: 0 0.7em;
`
const ResendButton = styled(Button)`
    margin: 0 0.5em;
`

const UserItem = ({ e }) => {

    const [hover, setHover] = useState(false)

    const resendEmail = (order) => {
        Modal.Promise({
            title: 'Resending Email',
            body: <Loading />,
            callback: HamQuest.getQuery(QuestRoute.purchase.resendOrderEmail, {
                transRecordId: order.transRecordId
            })
        })
            .then(() =>
                Modal.Show({
                    title: 'Success',
                    body: 'Email resent.',
                    type: 'success',
                })
            )
    }

    return (
        <Item
            key={generateId()}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <Row>
                <Row>
                    <div>{new Date(e.purchaseDate).toLocaleString()}</div>
                    {
                        hover
                        && e.purchasedProducts.find(p => !p.fulfillable && p.appProductType !== 'AppClub')
                        && <ResendButton onClick={() => resendEmail(e)}>Resend to Email</ResendButton>
                    }
                </Row>
                <Indent>{currency.format(e.total)}</Indent>
            </Row>
            {
                e.purchasedProducts.map(f =>
                    <Indent key={generateId()}>
                        <Col>
                            <div>{f.name} {f.isGift ? <Icon icon='gift' /> : null}</div>
                            {
                                f.isGift ? <Indent>Gifted To: {f.giftedEmail}</Indent> : null
                            }
                        </Col>
                        <Indent>{f.quantity ?? "1"} x {currency.format(f.unitPrice)}</Indent>
                    </Indent>
                )
            }
        </Item>
    )
}

const UserHistory = () => {
    const {
        state: {
            active_user,
            isOffline
        },
    } = useGlobalState();

    const [history, setHistory] = useState(null)

    useEffect(() => {
        HamQuest.get(QuestRoute.user.purchaseHistory)
            .then(res => setHistory(res))
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get History',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    if (!history) return;

    return (
        <Wrapper>
            {
                history.length ?
                    <Card title='Purchase History' icon='history' collapsible>
                        {
                            history
                                .sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate))
                                .map(e => <UserItem e={e} />)
                        }
                    </Card> :
                    <>
                        You haven't made any purchases yet.
                    </>
            }
        </Wrapper>

    )
}

export default UserHistory;
